import React, { useEffect, useState } from 'react';
import './Banners.css';

export const DismissibleBanner = ({ message, onDismiss }) => {
    if (!message) return null;
    return (
        <div className="app-banner app-banner-error" role="alert">
            <span>{message}</span>
            <button type="button" className="app-banner-action" onClick={onDismiss}>
                Закрыть
            </button>
        </div>
    );
};

export const DraftNotice = ({ show, onDiscard }) => {
    if (!show) return null;
    return (
        <div className="app-banner app-banner-draft" role="status">
            <span>Восстановлен черновик</span>
            <button type="button" className="app-banner-action" onClick={onDiscard}>
                Отменить черновик
            </button>
        </div>
    );
};

const formatDraftDate = (timestamp) => new Date(timestamp).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
});

export const DraftConflictPrompt = ({ conflict, subject = 'заказ', onApply, onDiscard }) => {
    if (!conflict) return null;
    return (
        <div className="app-banner app-banner-draft app-banner-wrap" role="alert">
            <span>Есть черновик от {formatDraftDate(conflict.savedAt)}, но {subject} с тех пор изменился</span>
            <span className="app-banner-actions">
                <button type="button" className="app-banner-action" onClick={onApply}>
                    Применить черновик
                </button>
                <button type="button" className="app-banner-action" onClick={onDiscard}>
                    Отбросить
                </button>
            </span>
        </div>
    );
};

export const OfflineBanner = () => {
    const [offline, setOffline] = useState(() => navigator.onLine === false);

    useEffect(() => {
        const handleOnline = () => setOffline(false);
        const handleOffline = () => setOffline(true);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!offline) return null;
    return (
        <div className="offline-banner" role="status">
            Нет подключения к интернету. Данные могут быть устаревшими, сохранение не сработает.
        </div>
    );
};
